import PropTypes from 'prop-types';
import {CITY_INFO} from 'city/city-prop-types';
import {CREDIT_WALLET_DATA, USER_DATA} from 'user/user-prop-types';

export const PROMO_CODE_DATA = {
    codeType: PropTypes.string,
    discountAmount: PropTypes.number,
    percentageOff: PropTypes.number,
    code: PropTypes.string,
    discountDisplayAmount: PropTypes.string,
    promoCodeDetails: PropTypes.string,
};

export const CHECKOUT_ERROR_DATA = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
};

export const HERO_CONTROLS_DATA = {
    rebookReservationId: PropTypes.bool,
    isRebookingReservation: PropTypes.bool,
    paymentRequired: PropTypes.bool,
    purchaseForCustomer: PropTypes.bool,
    purchaseOnBehalfOfCustomer: PropTypes.bool,
    paymentRequiredNoCharge: PropTypes.bool, // Payment is required but credit/promo covers cost
};

export const checkoutDataProps = {
    ...CREDIT_WALLET_DATA,
    ...HERO_CONTROLS_DATA,
    adminUser: PropTypes.shape(USER_DATA),
    selectedRate: PropTypes.object,
    checkoutError: PropTypes.shape(CHECKOUT_ERROR_DATA),
    highlightAccountPanel: PropTypes.bool.isRequired,
    onReserveClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onBackToSearchClick: PropTypes.func,
    isMonthly: PropTypes.bool,
    cityInfo: CITY_INFO.isRequired,
    licensePlateRequired: PropTypes.bool,
    promoCode: PropTypes.shape(PROMO_CODE_DATA),
};
